<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          File not available
        </p>
        <button
          id="modal-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <p>This filing was filed by paper and is currently not available to be viewed online. Please contact support to request a copy to be made available.</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          id="modal-close-btn-2"
          type="button"
          class="button is-primary"
          @click="$emit('close')"
        >
          Close
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NoPaperFiling',
};
</script>